import { monthsList } from "./mockData";

export const clientID = () => {
    return '690168017784-t3kopoj1eaq5i84dpbr3q1sa1eilfdi3.apps.googleusercontent.com';
}

export const getURLBase = (testProd) => {
    return 'https://5xzfhwwvk3.execute-api.eu-west-2.amazonaws.com/v1';
    // return 'http://127.0.0.1:1234';
};

export const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export const getBrowseURL = () => {
    if (process.env.NODE_ENV !== 'development') {
        return "http://www.google.com";
    }
    return 'https://www.wyzr.co.uk';
};

export const updateParentafterDataUpdate = (parentID, childID) => {
    var parentEl = document.getElementById(parentID);
    var childEl = document.getElementById(childID);

    parentEl.style.height = childEl?.offsetHeight + "px";
}

export const updateHeightAfterContentUpdate = (parentID, childID, grandparentID = null, minus = 0) => {
    if (window.screen.width >= 600) {
        setTimeout(() => {
            var parentEl = document.getElementById(parentID);
            var childEl = document.getElementById(childID);
            if (parentEl) {

                parentEl.style.height = childEl?.offsetHeight  - minus + "px";
            }
            if (grandparentID) {
                var grandParentEl = document.getElementById(grandparentID);
                try {
                    
                    grandParentEl.style.height = childEl?.offsetHeight + "px";
                } catch (error) {
                    console.log(error);
                }
            }
        }, 2);
    }
}

export const isMobile = () => {
    // credit to Timothy Huang for this regex test: 
    // https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        return true
   }
   else{
        return false
   }
} 


export const updateParentHeight = (parentID, childID, toOpen, grandparentID = null) => {

    var parentEl = document.getElementById(parentID);
    if (window.screen.width >= 600) { //FOR DESKTOP
        if (toOpen) {//if we are opening the widget
            var childEl = document.getElementById(childID);
            parentEl.style.height = childEl?.offsetHeight + "px"; //make parent height same as child height to prevent overflowing child's content
            if (grandparentID) {
                var grandParentEl = document.getElementById(grandparentID);
                try{
                grandParentEl.style.height = childEl?.offsetHeight + "px"; //if grandpa exist than make it's height to child's height as well to prevent overflowing child's content
            } catch (error) {
                console.log(error);
            }
            }
        }
        
        else {//if we are closing the widget
            parentEl.style.height = "auto"; // child dissapears so make parent height again to auto
            if (grandparentID) {
                var grandParentEl = document.getElementById(grandparentID);
                grandParentEl.style.height = parentEl?.offsetHeight + "px"; //if grandpa exist than make its height to parent heights to prevent overflowing parent's content
            }
        }
    }
    else { //FOR MOBILES
        if (toOpen) {//if we are opening the widget
            //make parent height 0 and child height to fullscreen - 100vh to enable fullscreen mode
            document.body.style.overflow = "hidden";
            var childEl = document.getElementById(childID);
            childEl.style.height = "100vh";
            childEl.style.overflow = "scroll";
            parentEl.style.height = "0px";
            parentEl.style.overflow = "hidden";
            childEl.scrollIntoView({ behavior: "auto", block: "nearest", inline: "nearest" });
            if (grandparentID) {
                //if grandparent exist than make it height to 0
                var grandParentEl = document.getElementById(grandparentID);
                grandParentEl.style.height = "0px";
                grandParentEl.style.overflow = "hidden";

                childEl.style.top = "16px";
            }
        }
        else {//if we are closing the widget
            document.body.style.overflow = "auto";
            if (grandparentID) {
                var grandParentEl = document.getElementById(grandparentID);
                parentEl.style.height = "100vh";
                parentEl.style.overflow = "scroll";

                grandParentEl.style.height = "0px";
                grandParentEl.style.overflow = "hidden";
            }
            else {
                parentEl.style.height = "auto";
                parentEl.style.overflow = "hidden";
            }
            parentEl.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
        }
    }

}

export const getCurrentMonthIndex = () => {
    var m = new Date().getMonth();
    var index = monthsList.indexOf(m);
    return m;
}

export const generateDataforAllMonths = (singleData) => {
    var result = [];
    monthsList.forEach((el) => {
        var item = {};
        item.monthName = el;
        item.data = singleData;
        result.push(item);
    });

    return result;
}